










import Vue from 'vue'
import store from '@/store'
const menuList = [
  {
    name: '本地天气',
    path: '/current_weather',
  },
  {
    name: '气温监测',
    path: '/weather_monitor/tem',
  },
  {
    name: '降水监测',
    path: '/weather_monitor/pre',
  },
  {
    name: '风速风向',
    path: '/weather_monitor/wind',
  },
  {
    name: '相对湿度',
    path: '/weather_monitor/rhu',
  },
  {
    name: '预警信号',
    path: '/warn',
  },
  {
    name: '公众互动',
    path:'/weather_certificate'
  }
  // {
  //   name: '信息反馈',
  //   path: '/info_feedback',
  // },
  // {
  //   name: '我的定制',
  //   path: '/custom_message',
  // },
  // {
  //   name: '角色申请',
  //   path: '/apply_role',
  // },
  // {
  //   name: '消息列表',
  //   path: '/msg_list',
  // },
  // {
  //   name: '每日天气预报',
  //   path: '/daily_forecast',
  // },
  // {
  //   name: '气象知识',
  //   path: '/meteo_knowledge',
  // },
]
export default Vue.extend({
    data() {
        return {
            menuList,
        }
    },
    created() {
      // 水库员
      const token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiI3bDQ4bW8iLCJzdWIiOiJoNSYmJjY1MGY3Y2MzODljYTRjNjI5ODhkZTg4YjU5ZGNiZjM5IiwiZXhwIjoxNjQwMjI0OTQwLCJpYXQiOjE2Mzk2MjAxNDB9.BL9BOquemtSHhSSXaivIbRQ2WLSi-KH1TvufOZ3CAaj0W5Ju1UQZ9-dZ1eyXJdARz1ZAasBwc5lBf_Tipq1VOA'
      // 信息员
      // const token1 = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJ4ZnJudmkiLCJzdWIiOiJtaW5pJiYmMDM0ZjBhNDcyYWQ0NGE4ZTlmMmEyNmQzMTFlY2U0ZDQiLCJleHAiOjE2MzI0NzQ4MjIsImlhdCI6MTYzMTg3MDAyMn0.yUIwEaJL04pfOLtma7W6wIyqcHRHbjUzb-CGPXbKPbiow3cga4lGLYF9UDDMDHddCceMxaZYJ9QfsFoWMI4I_A'
      // store.commit('login', token )
    },
})
